import React from 'react';
import { Button, Grid, Popover, PopoverProps } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import PopupTitle from '../../../components/common/popup_title';
import { SharedProgramme } from '../../../API';

interface DeleteLinkedMealNotAllowedPopoverProps {
  anchorEl: PopoverProps['anchorEl'];
  sharedProgrammesLinked: SharedProgramme[];
  visible: boolean;
  onDismiss: () => void;
}

const DeleteLinkedMealNotAllowedPopover = ({
  anchorEl = null,
  sharedProgrammesLinked,
  visible,
  onDismiss,
}: DeleteLinkedMealNotAllowedPopoverProps) => {
  if (!visible) {
    return null;
  }

  return (
    <Popover
      open
      PaperProps={{
        style: { width: `380px`, height: `240px`, padding: '10px' },
      }}
      onClose={onDismiss}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText={
              <div style={{ display: 'flex' }}>
                <div style={{ display: 'flex', margin: 'auto' }}>
                  <ErrorIcon
                    style={{
                      width: '20px',
                      height: '20px',
                      color: 'red',
                      margin: 'auto 6px',
                    }}
                  />
                  <div>Cannot delete recipe</div>
                </div>
              </div>
            }
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          Cannot delete recipe as it is linked to a published program.
          <br />
          <br />
          Unpublish the associated published programs first. These are:
          <br />
          {sharedProgrammesLinked
            .map((sharedProgramme) => sharedProgramme.title)
            .join(', ')}
        </Grid>
        <Grid item xs={6} style={{ padding: '5px' }}>
          <Button
            onClick={(ev) => {
              onDismiss();
              ev.stopPropagation();
            }}
            variant="contained"
            color="primary"
            size="medium"
            disableElevation
            style={{ justifyContent: 'flex-start' }}>
            OK
          </Button>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default DeleteLinkedMealNotAllowedPopover;
